import React from 'react';

import { useIntl } from '@utils/intl';
import BaseBooking from '@views/Book/Book/BasicBook/Booking';
import { ParkingBookProps } from '@views/shared/interfaces/booking';

import { useBook } from './hooks';

export default function Booking({
  areaId,
  date,
  enabledHalfDayBooking,
  enabledHourlyBooking,
  hasNextDaysBooking,
  parkingId,
  type,
  showAvailability,
}: ParkingBookProps) {
  const { t, formats } = useIntl();

  const {
    bookablePeriod,
    blockedTimeSlots,
    book,
    error,
    errorBooking,
    loading,
    loadingBooking,
    selectedSlots,
    setSlots,
    midDayHour,
    updateComment,
    isQuotaReached,
  } = useBook({
    date,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    formats,
    params: {
      areaId,
      parkingId,
    },
    t,
    type,
  });

  return (
    <BaseBooking
      enabledHalfDayBooking={enabledHalfDayBooking}
      enabledHourlyBooking={enabledHourlyBooking}
      bookablePeriod={bookablePeriod}
      blockedTimeSlots={blockedTimeSlots}
      book={book}
      selectedSlots={selectedSlots}
      error={error}
      errorBooking={errorBooking}
      loading={loading}
      loadingBooking={loadingBooking}
      setSlots={setSlots}
      midDayHour={midDayHour}
      showAvailability={showAvailability}
      updateComment={updateComment}
      isQuotaReached={isQuotaReached}
    />
  );
}
